import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { AUTH_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage } from "react-intl";
import TooltipHelp from "../Help/ToolTipHelp";

export default function DeleteUser() {
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="DeleteRestoreUser" />
            <TooltipHelp
              id="FinalExam"
              toolTipText={
                <FormattedMessage id="NonActivatedDeletedCannotBeRestoredHere" />
              }
              placement="right"
            />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <p>
            <Input id="user-delete-email" placeholder="email" />
          </p>
          <div>
            <p>
              <input
                type="radio"
                id="radioDeleteUser"
                name="deleteRestoreUser"
                defaultChecked
              />{" "}
              <FormattedMessage id="Delete" />
            </p>
            <input
              type="radio"
              id="radioRestoreUser"
              name="deleteRestoreUser"
            />{" "}
            <FormattedMessage id="Restore" />
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            onClick={() => {
              var isDeleteOperation =
                document.getElementById("radioDeleteUser").checked;
              var userEmail = document
                .getElementById("user-delete-email")
                .value.trim();

              axios
                .post(`${AUTH_BASE_URL}/token/SetLockout`, {
                  email: userEmail,
                  lockout: isDeleteOperation,
                })
                .then((res) => {
                  if (res.status === 202) {
                    toast.success(res.data);
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });

              axios
                .post(
                  `${API_BASE_URL}/User/SetDeleted?email=${encodeURIComponent(
                    userEmail
                  )}&isDeleted=${isDeleteOperation}`
                )
                .then((response) => {
                  if (response?.data?.result?.name) {
                    var userName = response.data.result.name;
                    var isDeleted = response.data.result.isDeleted
                      ? "JA"
                      : "NEJ";

                    toast.success(
                      userName + " har nu status Raderad: " + isDeleted
                    );
                  } else {
                    toast.warn("Svaret från servern var inte korrekt");
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });
            }}
          >
            <FormattedMessage id="DeleteRestore" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
